<div class="filter-group" [ngClass]="{ collapsed: isCollapsed }">
  <h3 (click)="toggle()" [attr.aria-expanded]="!isCollapsed" [attr.aria-controls]="'filter-list_' + title()">
    {{ title() }}
    <fa-icon [icon]="['fas', isCollapsed ? 'angle-down' : 'angle-up']" />
  </h3>

  <ng-content />
</div>
